import type { DataTableRowData, DataTableInstance, DataTableOptions } from '../types'
import { useTableTableInstance } from './use-table-instance'
import { useCxTableOptions } from './use-table-options'

export const useCxDataTable = <TData extends DataTableRowData>(
  tableOptions: DataTableOptions<TData>,
): DataTableInstance<TData> => useTableTableInstance(useCxTableOptions(tableOptions))
